import React from "react";
import StyledLink from "./small-styled-link";

const ArchiveLink = () => {
  return (
    <div>
      <h3 className="text-2xl font-bold font-title">Archives</h3>
      <ul>
        <li>
          <StyledLink to={`/blog/archive`}>View full archives</StyledLink>
        </li>
      </ul>
    </div>
  );
};

export default ArchiveLink;
